import { useState } from "react";
import "../../../../design/communityArticles.css";
import Footer from "../Footer";
import { motion, AnimatePresence } from "framer-motion";
import { IoCloseOutline } from "react-icons/io5";

export default function CommunityArticles() {
    const [selectedArticle, setSelectedArticle] = useState(null);

    const articles = [
        {
            type: "teacher",
            title: "მასწავლებლის ისტორია",
            intro: "როგორ პოულობს მასწავლებელი ახალ მოსწავლეებს და როგორ შეიცვალა მისი პროფესიული ცხოვრება.",
            content: "„წლების განმავლობაში რეპეტიტორობა ჩემი შემოსავლის მთავარი წყარო იყო, თუმცა მოსწავლეების მოძიება ყოველთვის ნაცნობების წრეზე იყო დამოკიდებული. Teacher Hub-ის აღმოჩენის შემდეგ, მოსწავლეების პოვნა გამარტივდა. ჩემი პროფილის შექმნიდან სულ რამდენიმე დღეში, რამდენიმე მშობელი თავად დამიკავშირდა. პლატფორმა დამეხმარა ჩემი სამუშაო გრაფიკის იდეალურად ორგანიზებაში, ხოლო ინტეგრირებულმა გადახდის სისტემამ ფინანსური ურთიერთობები აბსოლუტურად გამჭვირვალე და კომფორტული გახადა. ახლა მე თავად ვმართავ ჩემს დროს და მაქვს სტაბილური, მზარდი პროფესიული კარიერა.“ \n\n— მარიამი, მათემატიკის წამყვანი სპეციალისტი."
        },
        {
            type: "parent",
            title: "მშობლის გამოცდილება",
            intro: "მშობლები გვიყვებიან, რამდენად მარტივი გახდა სწორი პედაგოგის შერჩევა მათი შვილებისთვის.",
            content: "„როგორც მომუშავე მშობლისთვის, ჩემი შვილისთვის შესაფერისი ფიზიკის მასწავლებლის პოვნა ნამდვილი გამოწვევა იყო. საათობით ვკითხულობდი ფეისბუქ პოსტებს, კომენტარებს და ვეკითხებოდი მეგობრებს, მაგრამ ხშირად შედეგით უკმაყოფილო ვრჩებოდით. სად, რომ 6-იანს ზრდილობის გამო უწერენ და სად, რომ დამსახურებულ 8, 9 და 10 ქულებს იღებს, რა შედარებაა! ამ პლატფორმამ ძიების პროცესი წარმოუდგენლად გაამარტივა. ლოკაციისა და საგნის მიხედვით ფილტრაციამ საშუალება მომცა ზუსტად ჩვენს უბანში მეპოვა გამოცდილი პედაგოგი. იმასაც კი ვხედავ მასწაველბლამდე რომელი ავტობუსით, სამარშრუტო ტაქსით, მატარებლითა თუ ტაქსით, ფეხით თუ პირადი ტრანსპორტით როგორ მოვხვდე უმოკლეს დროში, რაც გადაწყვეტილების მიღებაში დამეხმარა. ჩემი შვილის ნიშნები და მოტივაცია სულ რაღაც ორ თვეში საგრძნობლად გაუმჯობესდა. მადლობა ასეთი საჭირო სივრცისთვის!“ \n\n— ნინო, 12 წლის ლუკას დედა."
        },
        {
            type: "school",
            title: "სკოლების ხედვა",
            intro: "სკოლები საუბრობენ იმაზე, როგორ ეხმარება პლატფორმა განათლების საერთო ხარისხის ამაღლებას.",
            content: "„თანამედროვე საგანმანათლებლო ეკოსისტემაში უმნიშვნელოვანესია კავშირი ფორმალურ და არაფორმალურ განათლებას შორის. Teacher Hub-ის გამოჩენამ ჩვენს მოსწავლეებს მისცა უნიკალური შესაძლებლობა, სკოლის მიღმა მიიღონ მიზნობრივი, მათ საჭიროებებზე მორგებული აკადემიური მხარდაჭერა. ჩვენ ვხედავთ, რომ მოსწავლეები, რომლებიც იყენებენ ამ პლატფორმას ინდივიდუალური მომზადებისთვის, საკლასო ოთახებში გაცილებით მაღალ ჩართულობასა და პროგრესს აჩვენებენ. ეს ინსტრუმენტი ეფექტურად ავსებს სასკოლო პროგრამას და ეხმარება ახალგაზრდებს ეროვნული გამოცდებისთვის უკეთ მომზადებაში.“ \n\n— თბილისის საჯარო სკოლის ადმინისტრაცია."
        },
        {
            type: "kid",
            title: "ბავშვების აზრი",
            intro: "როგორ იპოვეს საინტერესო მასწავლებელი და როგორ გახდა სწავლა უფრო საინტერესო და ხშირად მხიარულიც.",
            content: "„ყოველთვის მეგონა, რომ ინგლისური ენის სწავლა და გრამატიკის წესების დაზუთხვა ყველაზე მოსაწყენი რამ იყო მსოფლიოში. მაგრამ აქ ისეთი მასწავლებელი ვიპოვე, რომ გაკვეთილის დაწყებას ყოველდღე მოუთმენლად ველოდები! ჩვენ მხოლოდ წიგნებით კი არ ვსწავლობთ, არამედ ვუყურებთ ჩემს საყვარელ ანიმაციებს, ვთამაშობთ ინტერაქტიულ თამაშებს და ვსაუბრობთ საინტერესო თემებზე. სკოლაში ნიშნებიც გამოვასწორე და ახლა უკვე თავისუფლად შემიძლია ჩემთვის საინტერესო სპორტს დავუთმო! სწავლა ყოფილა ძალიან მხიარული! 🚀✨“ \n\n— სანდრო, 10 წლის."
        },
    ];

    const themes = {
        teacher: { bg: "rgba(0, 122, 255, 0.05)", text: "#007AFF", badge: "პროფესიული" },
        parent: { bg: "rgba(255, 149, 0, 0.05)", text: "#FF9500", badge: "ოჯახური" },
        school: { bg: "rgba(255, 59, 48, 0.05)", text: "#FF3B30", badge: "აკადემიური" },
        kid: { bg: "rgba(52, 199, 89, 0.05)", text: "#34C759", badge: "სასკოლო" },
    };

    return (
        <>
            <section className="community">
                <div className="community-container">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8 }}
                    >
                        <h2 className="community-title">
                            რას ამბობენ ჩვენი <span className="highlight">მომხმარებლები</span>
                        </h2>
                        <p className="community-intro">
                            ამ სივრცეში ქვეყნდება სტატიები, რომლებიც დაწერილია
                            მასწავლებლების, მშობლების, სკოლებისა და ბავშვების მიერ.
                        </p>
                    </motion.div>

                    <div className="timeline">
                        <div className="timeline-line"></div>
                        {articles.map((article, index) => {
                            const currentTheme = themes[article.type];
                            return (
                                <motion.div
                                    key={index}
                                    initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
                                    whileInView={{ opacity: 1, x: 0 }}
                                    viewport={{ once: true, margin: "-100px" }}
                                    transition={{ duration: 0.6, delay: index * 0.1 }}
                                    className={`timeline-item ${index % 2 === 0 ? "left" : "right"}`}
                                >
                                    <div className="number-node" style={{ backgroundColor: currentTheme.text }}>
                                        {index + 1}
                                    </div>
                                    <div
                                        className="content-card"
                                        style={{
                                            background: currentTheme.bg,
                                            borderColor: currentTheme.text
                                        }}
                                    >
                                        <span className="card-badge" style={{ color: currentTheme.text, borderColor: currentTheme.text }}>
                                            {currentTheme.badge}
                                        </span>
                                        <h3 style={{ color: currentTheme.text }}>
                                            {article.title}
                                        </h3>
                                        <p>{article.intro}</p>
                                        <motion.button
                                            whileHover={{ scale: 1.05 }}
                                            whileTap={{ scale: 0.95 }}
                                            className='communityArticlesButton'
                                            style={{ backgroundColor: currentTheme.text }}
                                            onClick={() => setSelectedArticle(article)}
                                        >
                                            სრულად ნახვა
                                        </motion.button>
                                    </div>
                                </motion.div>
                            );
                        })}
                    </div>
                </div>
            </section>

            {/* DYNAMIC DESIGN OVERLAY MODAL */}
            <AnimatePresence>
                {selectedArticle && (
                    <div className="art-modal-overlay" onClick={() => setSelectedArticle(null)}>
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0, y: 30 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.9, opacity: 0, y: 30 }}
                            transition={{ type: "spring", damping: 25, stiffness: 350 }}
                            className={`art-modal-body article-theme-${selectedArticle.type}`}
                            onClick={(e) => e.stopPropagation()}
                        >
                            <button className="art-close-btn" onClick={() => setSelectedArticle(null)}>
                                <IoCloseOutline size={26} />
                            </button>

                            {/* Dynamic Graphic Background Context Elements */}
                            <div className="theme-graphic-decoration"></div>

                            <div className="art-modal-content">
                                <span className="art-modal-badge">{themes[selectedArticle.type].badge}</span>
                                <h2 className="art-modal-title">{selectedArticle.title}</h2>
                                <div className="art-modal-scroll-text">
                                    <p>{selectedArticle.content}</p>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <Footer />
        </>
    );
}